/* eslint-disable no-nested-ternary */
import { useDidMount } from 'hooks';
import PropType from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { applyFilter, resetFilter } from 'redux/actions/filterActions';
import { getBrands } from 'redux/actions/homeActions';
import { useTranslation } from 'react-i18next';
import { selectMax, selectMin } from 'selectors/selector';
import PriceRange from './PriceRange';
import regioni from '../../files/regioni.json';
import province from '../../files/province.json';
import npaCodes from '../../files/npa.json';
import firebase from '../../firebase/firebase';

const Filters = ({ closeModal }) => {
  const { t } = useTranslation();
  const { filter, isLoading, products } = useSelector((state) => ({
    filter: state.filter,
    isLoading: state.app.loading,
    products: state.products.items
  }));
  const [field, setFilter] = useState({
    year: filter.year,
    brand: filter.brand,
    size: filter.size,
    assisted: filter.assisted,
    weight: filter.weight,
    wheels: filter.wheels,
    sub1: filter.sub1,
    type: filter.type,
    npa: filter.npa,
    region: filter.region,
    province: filter.province,
    minPrice: filter.minPrice,
    maxPrice: filter.maxPrice,
    sortBy: filter.sortBy
  });
  const dispatch = useDispatch();
  const didMount = useDidMount();

  const max = selectMax(products);
  const min = selectMin(products);

  useEffect(() => {
    if (didMount && closeModal) closeModal();

    setFilter(filter);
    window.scrollTo(0, 0);
  }, [filter]);

  const regionList = [
    <option key="0" value="">
      {t('menuFilterAnyRegion')}
    </option>
  ];
  regioni.map((data) =>
    regionList.push(
      <option key={data.nome} value={data.nome}>
        {data.nome}
      </option>
    )
  );

  const [addressList] = useState({
    province: [
      <option key="0" value="">
        {t('menuFilterAnyProvince')}
      </option>
    ]
  });
  function parseProvinces(selectedRegion) {
    addressList.province.splice(1, addressList.province.length);
    province
      .filter((data) => data.regione === selectedRegion)
      .map((data) =>
        addressList.province.push(
          <option key={data.nome} value={data.nome}>
            {data.nome}
          </option>
        )
      );
  }
  parseProvinces(field.region);

  const npaList = [
    <option key="0" value="">
      {t('menuFilterAnyNPA')}
    </option>
  ];
  const keys = Object.keys(npaCodes);
  keys.map((data) =>
    npaList.push(
      <option key={data} value={data}>
        {data}
      </option>
    )
  );

  const assistedList = [
    <option key="0" value="">
      {t('productFormAnyPedaling')}
    </option>,
    <option key="Non Assistita" value="Non Assistita">
      {t('productFormNotAssisted')}
    </option>,
    <option key="Assistita" value="Assistita">
      {t('productFormAssisted')}
    </option>
  ];

  function generateArrayOfYears() {
    const maxYear = new Date().getFullYear();
    const minYear = 1900;
    const years = [
      <option key="0" value="">
        {t('productFormAnyYear')}
      </option>
    ];
    for (let i = maxYear; i >= minYear; i -= 1) {
      years.push(
        <option key={i.toString()} value={i.toString()}>
          {i.toString()}
        </option>
      );
    }
    return years;
  }
  const yearsList = generateArrayOfYears();

  const brandsSelector = useSelector((state) => state.home.brands);
  useEffect(() => {
    if (brandsSelector.length === 0) dispatch(getBrands());
  }, []);
  const brandsList = [
    <option key="0" value="Non Specificata">
      {t('productFormAnyBrand')}
    </option>
  ];
  brandsSelector.map((brand) =>
    brandsList.push(
      <option key={brand.name} value={brand.name}>
        {brand.name}
      </option>
    )
  );

  const onRegionFilterChange = (e) => {
    const val = e.target.value;
    setFilter({ ...field, region: val, province: '' });
    parseProvinces(e.target.value);
  };

  const onProvinceFilterChange = (e) => {
    const val = e.target.value;
    setFilter({ ...field, province: val });
  };

  const onNpaFilterChange = (e) => {
    setFilter({ ...field, npa: e.target.value });
  };

  const onPriceChange = (minVal, maxVal) => {
    setFilter({ ...field, minPrice: minVal, maxPrice: maxVal });
  };

  const onSortFilterChange = (e) => {
    setFilter({ ...field, sortBy: e.target.value });
  };

  const onTypeFilterChange = (e) => {
    setFilter({ ...field, type: e.target.value });
  };

  const onSub1FilterChange = (e) => {
    setFilter({ ...field, sub1: e.target.value });
  };

  const onYearFilterChange = (e) => {
    setFilter({ ...field, year: e.target.value });
  };

  const onSizeFilterChange = (e) => {
    setFilter({ ...field, size: e.target.value });
  };

  const onAssistedFilterChange = (e) => {
    setFilter({ ...field, assisted: e.target.value });
  };

  const onBrandFilterChange = (e) => {
    setFilter({ ...field, brand: e.target.value });
  };

  const onApplyFilter = () => {
    const isChanged = Object.keys(field).some(
      (key) => field[key] !== filter[key]
    );

    if (field.minPrice > field.maxPrice) {
      return;
    }

    if (isChanged) {
      dispatch(applyFilter(field));
    } else {
      closeModal();
    }
  };

  const onResetFilter = () => {
    const filterFields = [
      'year',
      'assisted',
      'brand',
      'size',
      'weight',
      'wheels',
      'sub1',
      'type',
      'npa',
      'region',
      'province',
      'minPrice',
      'maxPrice',
      'sortBy'
    ];

    if (filterFields.some((key) => !!filter[key])) {
      dispatch(resetFilter());
    } else {
      closeModal();
    }
  };

  return (
    <div className="filters">
      <div className="filters-field">
        <span>{t('productFormType')}</span>
        <br />
        <br />
        {products.length === 0 && isLoading ? (
          <h5 className="text-subtle">{t('loadingMessage')}</h5>
        ) : (
          <select
            className="d-block"
            value={field.type}
            disabled={isLoading || products.length === 0}
            onChange={onTypeFilterChange}
          >
            <option value="">{t('productFormAnyType')}</option>
            <option value="Bicicletta">{t('productFormBike')}</option>
            <option value="Accessorio">{t('productFormAccessory')}</option>
          </select>
        )}
      </div>
      {field.type === 'Bicicletta' && (
        <>
          <div className="filters-field">
            <span>{t('productFormSub')}</span>
            <br />
            <br />
            {products.length === 0 && isLoading ? (
              <h5 className="text-subtle">{t('loadingMessage')}</h5>
            ) : (
              <select
                className="d-block"
                value={field.sub1}
                disabled={isLoading || products.length === 0}
                onChange={onSub1FilterChange}
              >
                <option value="">{t('productFormAnySub')}</option>
                <option value="Strada">{t('productFormStreet')}</option>
                <option value="Mountain Bike">Mountain Bike</option>
                <option value="Kids 0-12">Kids 0-12</option>
                <option value="Specials">Specials</option>
              </select>
            )}
          </div>
          <div className="filters-field">
            <span>{t('productFormBrand')}</span>
            <br />
            <br />
            {products.length === 0 && isLoading ? (
              <h5 className="text-subtle">{t('loadingMessage')}</h5>
            ) : (
              <select
                className="d-block"
                value={field.brand}
                disabled={isLoading || products.length === 0}
                onChange={onBrandFilterChange}
              >
                {brandsList}
              </select>
            )}
          </div>
          <div className="filters-field">
            <span>{t('productFormYear')}</span>
            <br />
            <br />
            {products.length === 0 && isLoading ? (
              <h5 className="text-subtle">{t('loadingMessage')}</h5>
            ) : (
              <select
                className="d-block"
                value={field.year}
                disabled={isLoading || products.length === 0}
                onChange={onYearFilterChange}
              >
                {yearsList}
              </select>
            )}
          </div>
          <div className="filters-field">
            <span>{t('productFormPedaling')}</span>
            <br />
            <br />
            {products.length === 0 && isLoading ? (
              <h5 className="text-subtle">{t('loadingMessage')}</h5>
            ) : (
              <select
                className="d-block"
                value={field.assisted}
                disabled={isLoading || products.length === 0}
                onChange={onAssistedFilterChange}
              >
                {assistedList}
              </select>
            )}
          </div>
          <div className="filters-field">
            <span>{t('productFormSize')}</span>
            <br />
            <br />
            {products.length === 0 && isLoading ? (
              <h5 className="text-subtle">{t('loadingMessage')}</h5>
            ) : (
              <select
                className="d-block"
                value={field.size}
                disabled={isLoading || products.length === 0}
                onChange={onSizeFilterChange}
              >
                <option value="">{t('productFormAnySize')}</option>
                <option value="S">S</option>
                <option value="M">M</option>
                <option value="L">L</option>
                <option value="XL">XL</option>
              </select>
            )}
          </div>
        </>
      )}
      {firebase.clientLocation === 'Italia' && (
        <>
          <div className="filters-field">
            <span>{t('menuFilterRegion')}</span>
            <br />
            <br />
            {products.length === 0 && isLoading ? (
              <h5 className="text-subtle">{t('loadingMessage')}</h5>
            ) : (
              <select
                className="filters-region"
                value={field.region}
                disabled={isLoading || products.length === 0}
                onChange={onRegionFilterChange}
              >
                {regionList}
              </select>
            )}
          </div>
          <div className="filters-field">
            <span>{t('menuFilterProvince')}</span>
            <br />
            <br />
            {products.length === 0 && isLoading ? (
              <h5 className="text-subtle">{t('loadingMessage')}</h5>
            ) : (
              <select
                className="filters-province"
                value={field.province}
                disabled={isLoading || products.length === 0}
                onChange={onProvinceFilterChange}
              >
                {addressList.province}
              </select>
            )}
          </div>
        </>
      )}
      {firebase.clientLocation === 'Svizzera' && (
        <div className="filters-field">
          <span>{t('menuFilterNPA')}</span>
          <br />
          <br />
          {products.length === 0 && isLoading ? (
            <h5 className="text-subtle">{t('loadingMessage')}</h5>
          ) : (
            <select
              className="filters-npa"
              value={field.npa}
              disabled={isLoading || products.length === 0}
              onChange={onNpaFilterChange}
            >
              {npaList}
            </select>
          )}
        </div>
      )}
      <div className="filters-field">
        <span>{t('menuFilterOrder')}</span>
        <br />
        <br />
        <select
          className="filters-sort-by d-block"
          value={field.sortBy}
          disabled={isLoading || products.length === 0}
          onChange={onSortFilterChange}
        >
          <option value="">{t('menuFilterOrderNull')}</option>
          <option value="name-asc">{t('menuFilterOrderNameAsc')}</option>
          <option value="name-desc">{t('menuFilterOrderNameDesc')}</option>
          <option value="price-desc">{t('menuFilterOrderPriceDesc')}</option>
          <option value="price-asc">{t('menuFilterOrderPriceAsc')}</option>
          <option value="date-desc">{t('menuFilterOrderDateDesc')}</option>
          <option value="date-asc">{t('menuFilterOrderDateAsc')}</option>
        </select>
      </div>
      <div className="filters-field">
        <span>
          {t('menuFilterPrice')} ({firebase.clientCurrency})
        </span>
        <br />
        <br />
        {(products.length === 0 && isLoading) || max === 0 ? (
          <h5 className="text-subtle">{t('loadingMessage')}</h5>
        ) : products.length === 1 ? (
          <h5 className="text-subtle">{t('menuFilterPriceNull')}</h5>
        ) : (
          <PriceRange
            min={min}
            max={max}
            initMin={field.minPrice}
            initMax={field.maxPrice}
            isLoading={isLoading}
            onPriceChange={onPriceChange}
            productsCount={products.length}
          />
        )}
      </div>
      <div className="filters-action">
        <button
          className="filters-button button button-small"
          disabled={isLoading || products.length === 0}
          onClick={onApplyFilter}
          type="button"
        >
          {t('menuFilterButtonApply')}
        </button>
        <button
          className="filters-button button button-muted button-small"
          disabled={isLoading || products.length === 0}
          onClick={onResetFilter}
          type="button"
        >
          {t('menuFilterButtonReset')}
        </button>
      </div>
    </div>
  );
};

Filters.propTypes = {
  closeModal: PropType.func.isRequired
};

export default withRouter(Filters);
